import { BlockNoteEditor } from '@blocknote/core';
import { getAuthHeaders } from '../auth';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8788';

interface UploadOptions {
  aiGenerated: boolean;
}

export async function uploadVideo(
  editor: BlockNoteEditor,
  options: UploadOptions,
): Promise<void> {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'video/mp4,video/webm,video/ogg';
  input.multiple = false;

  input.onchange = async () => {
    const file = input.files?.[0];
    if (!file) return;

    const currentBlock = editor.getTextCursorPosition();
    const insertAfter = currentBlock.block;

    const [placeholderBlock] = editor.insertBlocks(
      [{ type: 'paragraph', content: [{ type: 'text', text: '\u{23F3} Uploading video\u2026', styles: { italic: true } }] }],
      insertAfter,
    );

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('ai_generated', String(options.aiGenerated));

      const res = await fetch(`${API_URL}/v1/video/upload`, {
        method: 'POST',
        headers: { ...getAuthHeaders() },
        body: formData,
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({ error: res.statusText }));
        throw new Error(err.error || `Upload failed (${res.status})`);
      }

      const data = await res.json();

      editor.removeBlocks([placeholderBlock]);

      editor.insertBlocks(
        [{
          type: 'video',
          props: {
            url: data.url,
            name: file.name,
            caption: options.aiGenerated ? 'AI-generated \u2014 EU AI Act labelled' : '',
          },
        }],
        insertAfter,
      );
    } catch (err: any) {
      editor.removeBlocks([placeholderBlock]);
      editor.insertBlocks(
        [{
          type: 'paragraph',
          content: [{ type: 'text', text: `\u274C Video upload failed: ${err.message}`, styles: { italic: true } }],
        }],
        insertAfter,
      );
    }
  };

  input.click();
}
